export default __webpack_public_path__ + "static/media/i35.85ab9770.jpeg";